import React from "react";

const OurStory = () => {
  return (
    <section className="bg-redlightlight px-6 py-24 h-screen flex items-center">
      <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-10">
        {/* Left content */}
        <div className="lg:w-1/2 text-center lg:text-left">
          <div className="flex items-center justify-center lg:justify-start mb-4">
            <img src="/logo/icon.png" alt="Timely" className="w-6 h-6 mr-2" />
          </div>

          <h2 className="text-4xl font-serif font-medium text-gray-800 mb-4">
            This is our story
          </h2>

          <hr className="w-16 border-gray-400 border mb-4 mx-auto lg:mx-0" />

          <p className="text-gray-700 text-base leading-relaxed">
            Big things often start small. Explore the journey that turned our
            idea into something meaningful.
          </p>
        </div>

        {/* Right image */}
        <div className="lg:w-1/2 rounded-2xl overflow-hidden  border-2 border-redlight">
          <img
            src="/logo/lokalai25.jpg"
            alt="Timely Team"
            className="w-full aspect-[9/9] object-cover rounded-md grayscale"
          />
        </div>
      </div>
    </section>
  );
};

export default OurStory;
